import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import View from '../../../modules/withdrawal/components/coordinator/View';

const ViewPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('withdrawal->>Coordinator.Summary.View.TitleHeader')} />
      <View />
    </>
  );
};

export default ViewPage;
